import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { RightChevron } from 'images'

import {
  breakpoints,
  CTA,
  Flex,
  P,
  ResponsiveImage,
  ResponsiveSVG
} from 'ui/acro'

const CardContainer = styled(Flex)(
  css({
    '&:not(:last-child)': {
      mr: ['0px', '16px', null, '45px']
    }
  })
)

const CategoryCard = forwardRef(({ alt, url, src, body, title }, ref) => {
  const imagesArray = [
    {
      src: src,
      breakpoint: breakpoints[0]
    }
  ]

  return (
    <CardContainer
      ref={ref}
      flexDirection='column'
      as='a'
      href={url}
      id={`home-category-link-${title}`}
      aria-label={`Explore ${title} classes`}
      className='swiper-slide unstyled'
      maxWidth={['240px', '320px']}
      flex={['', null, '1']}
    >
      <ResponsiveImage
        alt={alt}
        src={src}
        imagesArray={imagesArray}
        objectFit='cover'
      />
      <Flex
        flexDirection='row'
        justifyContent='flex-start'
        alignItems='center'
        mt='16px'
      >
        <CTA variant='heavy' color='grey6' mr={['10px', '16px']}>
          {title}
        </CTA>
        <ResponsiveSVG
          height='100%'
          width={['9px', '13px']}
          fill='grey5'
          SVG={RightChevron}
        />
      </Flex>
      <P color='grey5' mt='3px'>
        {body}
      </P>
    </CardContainer>
  )
})

CategoryCard.propTypes = {
  alt: PropTypes.string,
  url: PropTypes.string,
  src: PropTypes.string,
  body: PropTypes.string,
  title: PropTypes.string
}

export default CategoryCard
